// Shared constants for both StaticGrid and LazyGrid

export const PAGINATOR_POSITION = 'bottom'

export const PAGINATOR_TEMPLATE = 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'

export const CURRENT_PAGE_REPORT_TEMPLATE = 'Showing results {first}-{last} of {totalRecords}'

export const DEFAULT_ROWS_PER_PAGE_STATIC = 50

export const DEFAULT_ROWS_PER_PAGE_LAZY = 100

export const ROWS_PER_PAGE_OPTIONS_STATIC = [10, 25, DEFAULT_ROWS_PER_PAGE_STATIC, 100, 500]

export const ROWS_PER_PAGE_OPTIONS_LAZY = [10, 25, 50, DEFAULT_ROWS_PER_PAGE_LAZY]
